// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  margin-bottom: 20px;
}

ion-button {
  --background: #8bc34a;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-type-selection/order-type-selection.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AACE;EACE,qBAAA;AAEJ","sourcesContent":["ion-radio-group {\r\n    margin-bottom: 20px;\r\n  }\r\n  ion-button {\r\n    --background: #8bc34a;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
